export default __webpack_public_path__ + "static/media/EC_Calendar_Icon.004425de.svg";